(function () {
	let opener = null;

	function getModal() {
		return document.getElementById("search-modal");
	}

	function getVisibleFocusableElements(container) {
		return getFocusableElements(container).filter((element) => {
			const style = window.getComputedStyle(element);
			return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
		});
	}

	function keepFocusInSearch(event) {
		const modal = getModal();
		if (!modal?.classList.contains("active") || modal.contains(event.target)) return;
		modal.querySelector(".search__input")?.focus({ preventScroll: true });
	}

	function trapSearchTab(event) {
		const modal = getModal();
		if (event.key !== "Tab" || !modal?.classList.contains("active")) return;
		const focusable = getVisibleFocusableElements(modal);
		if (!focusable.length) return;
		const first = focusable[0];
		const last = focusable[focusable.length - 1];
		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		}
	}

	function openSearch(trigger) {
		const modal = getModal();
		if (!modal) return;

		opener = trigger;
		modal.classList.add("active");
		modal.setAttribute("aria-hidden", "false");
		document.querySelector(".header-overlay")?.classList.add("color-background-1");
		document.body.classList.add("overflow-hidden");
		removeTrapFocus();
		document.addEventListener("focusin", keepFocusInSearch);

		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				const input = modal.querySelector(".search__input");
				input?.focus({ preventScroll: true });
			});
		});
	}

	function closeSearch(restoreFocus = true) {
		const modal = getModal();
		if (!modal || !modal.classList.contains("active")) return;

		modal.classList.remove("active");
		modal.setAttribute("aria-hidden", "true");
		document.querySelector(".header-overlay")?.classList.remove("color-background-1");
		document.body.classList.remove("overflow-hidden");
		document.removeEventListener("focusin", keepFocusInSearch);
		if (restoreFocus && opener && document.contains(opener)) opener.focus();
		opener = null;
	}

	document.addEventListener("click", (event) => {
		const trigger = event.target.closest(".search-modal-trigger");
		const closeControl = event.target.closest(".search-modal__overlay, .search__close");
		if (!trigger && !closeControl) return;

		event.preventDefault();
		if (closeControl) {
			closeSearch();
		} else {
			openSearch(trigger);
		}
	});

	document.addEventListener("click", (event) => {
		if (event.target.closest(".header__icon--account")) closeSearch(false);
	}, true);

	document.addEventListener("keydown", (event) => {
		trapSearchTab(event);
		if (event.key === "Escape" && getModal()?.classList.contains("active")) {
			event.preventDefault();
			closeSearch();
		}
	});
})();
